<template>
  <div
    v-closable="{ exclude: ['contextInfoWrapper'], isClosable: isClosable, handler: 'closeEditable'}"
    class="context-item--wrapper"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div
      :ref="'contextInfoWrapper'"
      class="context--info__container"
      :class="{'editing': isEditable, 'editable': eventName !== null && !isLoading, 'custom-hover': ((hover || isEditable || customEditState) && actions.length > 0)}"
      @[eventName]="openEditable"
    >
      <template v-if="!flagHideOnEdit">
        <div v-if="icon !== null && !isLoading" class="context--info__icon">
          <v-tooltip left :disabled="iconTooltip === null">
            <template v-slot:activator="{ on }">
              <i v-on="on" :class="icon"></i>
            </template>
            <span>{{ iconTooltip }}</span>
          </v-tooltip>
        </div>
        <div v-else-if="isLoading" class="context--info__icon placeholderLoader">
          <i :class="icon"></i>
        </div>
        <div v-if="isLoading" class="context--info__text">
          <span class="attribute placeholderLoader">loading</span>
          <span class="value placeholderLoader">loading</span>
        </div>
        <div v-else-if="customText !== null" v-html="customText" class="context--info__text"></div>
        <div v-else class="context--info__text">
          <div v-if="customBody">
            <slot name="customBody"></slot>
          </div>
          <div v-else>
            <a target="_blank" v-if="hrefLink !== null" :href="hrefLink">
              <span v-show="attribute !== null" class="attribute">{{ attribute }}</span>
            </a>
            <span
              v-else-if="attribute !== null"
              v-show="attribute !== null && !isAttributeEditable && !isAutocompleteAttributeEditable"
              class="attribute"
            >{{ attribute }}</span>
            <input
              v-else
              v-show="attribute === null && !isAttributeEditable && !isAutocompleteAttributeEditable"
              class="editable--attribute"
              :placeholder="placeholderAttribute"
              :value="contentAttribute"
              disabled
            />
            <input
              v-show="isAttributeEditable && !customAttributeEdit"
              @input="handleAttributeEditableInput"
              class="editable--attribute"
              :placeholder="placeholderAttribute"
              :type="computedAttributeType"
              :value="contentAttribute"
              :ref="editableAttributeID"
            />
            <input
              v-show="isAutocompleteAttributeEditable && !customAttributeEdit"
              @input="handleAutocompleteAttributeEditableInput"
              class="editable--attribute"
              :type="computedAttributeType"
              :value="acAttrValue"
              :placeholder="attributePlaceholder"
              :ref="editableAutocompleteAttributeID"
            />
            <span
              v-show="value !== null && !isValueEditable"
              class="value"
            >{{ value }}{{ valueMeasurement }}</span>
            <input
              v-show="isValueEditable && !customValueEdit"
              @input="handleValueEditableInput"
              class="editable--value"
              :type="computedValueType"
              :value="contentValue"
              :ref="editableValueID"
            />
            <span v-show="isValueEditable && !customValueEdit" class="value">{{ valueMeasurement }}</span>
            <span v-show="isEditable" :ref="'slotEditableValue'">
              <slot
                :isOpen="isEditable"
                :openEdit="openEditable"
                :closeEdit="closeEditable"
                name="editValue"
              ></slot>
            </span>
            <span v-show="isEditable" :ref="'slotEditableAttribute'">
              <slot
                :isOpen="isEditable"
                :openEdit="openEditable"
                :closeEdit="closeEditable"
                name="editAttribute"
              ></slot>
            </span>
          </div>
          <div
            v-show="actions.length > 0 && (hover || isEditable || customEditState)"
            class="list-item-card-big__actions-panel"
          >
            <div class="icon-action" v-for="(action, index) in actions" :key="'action-' + index">
              <v-tooltip top :disabled="action.tooltip === undefined || action.tooltip === ''">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" size="18" @click="action.callback">{{action.icon}}</v-icon>
                  <!-- dependence on Vuetify   -->
                </template>
                <span>{{ action.tooltip }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </template>
      <div v-if="isEditable" class="context--info__edit">
        <slot
          :isOpen="isEditable"
          :openEdit="openEditable"
          :closeEdit="closeEditable"
          name="editInfo"
        ></slot>
      </div>
    </div>
    <div v-if="isExpanded">
      <slot name="expandablePart"></slot>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-sequences */
/* eslint-disable vue/no-side-effects-in-computed-properties */
import { uuid } from 'vue-uuid'
import { generalHelpers } from '@/_helpers'
export default {
  name: 'ContextItem',
  props: {
    contextInfoID: { type: String, default: null },
    icon: { type: String, default: null },
    attribute: { value: String | Number, default: null },
    placeholderAttribute: { type: String, default: null },
    value: { value: String | Number, default: null },
    valueMeasurement: { type: String, deafult: '' },
    isLoading: { type: Boolean, default: false },
    eventName: { type: String, default: null },
    eventHandler: { type: Object, default: () => {} },
    customText: { type: String, default: null },
    hideValueOnEdit: { type: Boolean, default: false },
    hideAttributeOnEdit: { type: Boolean, default: false },
    isAutocompleteAttribute: { type: Boolean, default: false },
    customValueEdit: { type: Boolean, default: false },
    customAttributeEdit: { type: Boolean, default: false },
    hrefLink: { type: String, default: null },
    isClosable: { type: Boolean, default: true },
    onClickHandler: { type: Function, default: () => 1 },
    iconTooltip: { type: String, default: null },
    actionIcons: { type: Object, default: () => null },
    isAutocompleteAttributePlaceholder: { type: Boolean, default: true },
    customBody: { type: Boolean, default: false },
    customEditState: { type: Boolean, default: false }
  },
  data () {
    return {
      isEditable: false,
      isValueEditable: false,
      isAttributeEditable: false,
      isAutocompleteAttributeEditable: false,
      flagHideOnEdit: false,
      editableAttributeID: null,
      editableAutocompleteAttributeID: null,
      editableValueID: null,
      contentAttribute: this.attribute,
      contentValue: this.value,
      acAttrValue: null,

      oldAttribute: '',
      copied: false,

      hover: false,
      isExpanded: false
    }
  },
  mounted () {
    this.editableAttributeID = uuid.v4()
    this.editableValueID = uuid.v4()
    this.editableAutocompleteAttributeID = uuid.v4()
  },
  methods: {
    openEditable (evt) {
      const clasList = [...evt.target.classList]
      if (clasList.length > 0 && clasList.includes('v-icon')) {
      } else if (this.actionIcons.edit === undefined && !!this.actionIcons.expand) {
        this.isExpanded = !this.isExpanded
      } else if (this.actionIcons.edit === 'normal') {
        this.$emit('normalEditEmitted')
        this.oldAttribute = this.attribute
        this.$nextTick(() => {
          if (this.hideAttributeOnEdit) {
            setTimeout(() => {
              this.$refs[this.editableAttributeID].focus()
            }, 20)
          }
          if (this.hideValueOnEdit) {
            setTimeout(() => {
              this.$refs[this.editableValueID].focus()
            }, 20)
          }
          if (this.isAutocompleteAttribute) {
            setTimeout(() => {
              this.$refs[this.editableAutocompleteAttributeID].focus()
            }, 20)
          }
        })
        if (evt.target.id === 'closeEdit') {
          this.isEditable = false
          // this.flagHideOnEdit = false
          this.isValueEditable = false
          this.isAttributeEditable = false
        } else {
          if (this.hideValueOnEdit) {
            if (
              this.$refs['slotEditableValue'].contains(evt.target) &&
              this.customValueEdit
            ) {
              this.isValueEditable = true
            } else {
              this.isValueEditable = !this.isValueEditable
            }
            if (this.isValueEditable) {
              this.onClickHandler()
            }
          }
          if (this.hideAttributeOnEdit) {
            if (
              this.$refs['slotEditableAttribute'].contains(evt.target) &&
              this.customAttributeEdit
            ) {
              this.isAttributeEditable = true
            } else {
              this.isAttributeEditable = !this.isAttributeEditable
            }
            if (this.isAttributeEditable) {
              this.onClickHandler()
            }
          }
          if (this.isAutocompleteAttribute) {
            this.contentAttribute = this.attribute
            this.isAutocompleteAttributeEditable = !this
              .isAutocompleteAttributeEditable
            if (!this.isAutocompleteAttributeEditable) {
              this.acAttrValue = null
            }
          }
          if (this.customValueEdit) {
            if (!this.$refs['slotEditableValue'].contains(evt.target)) {
              this.isEditable = !this.isEditable
            }
          }
          if (this.customAttributeEdit) {
            if (!this.$refs['slotEditableAttribute'].contains(evt.target)) {
              this.isEditable = !this.isEditable
            }
          }
          if (!this.customValueEdit && !this.customAttributeEdit) {
            this.isEditable = !this.isEditable
          }
        }
      } else if (this.actionIcons.edit === 'custom') {
        this.$emit('customEditEmitted')
      }
    },
    closeEditable (evt) {
      this.isEditable = false
      this.flagHideOnEdit = false
      this.isValueEditable = false
      this.isAttributeEditable = false
      this.isAutocompleteAttributeEditable = false
      this.contentAttribute = this.attribute
      this.acAttrValue = null
      this.$emit('cancelEditEmitted')
    },
    handleAttributeEditableInput (evt) {
      this.contentAttribute = evt.target.value
      this.$emit('input-attribute', this.contentAttribute)
    },
    handleValueEditableInput (evt) {
      this.contentValue = evt.target.value
      this.$emit('input-value', this.contentValue)
    },
    handleAutocompleteAttributeEditableInput (evt) {
      this.contentAttribute = evt.target.value
      this.acAttrValue = evt.target.value
      this.$emit('input-attribute', this.contentAttribute)
    }
  },
  computed: {
    computedValueType: function () {
      return this.attribute !== null ? typeof this.attribute : 'text'
    },
    computedAttributeType: function () {
      return this.value !== null ? typeof this.value : 'text'
    },
    attributePlaceholder: function () {
      if (this.isAutocompleteAttributePlaceholder) {
        return this.attribute
      }
      return null
    },

    actions () {
      let icons = []
      if (this.isEditable || this.customEditState) {
        icons.push(
          {
            icon: 'fas fa-times',
            tooltip: this.$i18n.t('buttons.cancel'),
            callback: e => {
              /* eslint-disable no-sequences */
              /* eslint-disable vue/no-side-effects-in-computed-properties */
              // eslint-disable-next-line no-unused-expressions
              this.$emit('input-attribute', this.oldAttribute),
              (this.contentAttribute = this.oldAttribute),
              (this.isEditable = false),
              (this.isValueEditable = false),
              (this.isAttributeEditable = false),
              this.$emit('cancelEditEmitted')
            }
          },
          {
            icon: 'fas fa-save',
            tooltip: this.$i18n.t('buttons.save'),
            callback: e => {
              /* eslint-disable no-sequences */
              /* eslint-disable vue/no-side-effects-in-computed-properties */
              // eslint-disable-next-line no-unused-expressions
              this.$emit('input-attribute', this.contentAttribute),
              (this.isEditable = false),
              (this.isValueEditable = false),
              (this.isAttributeEditable = false),
              this.$emit('saveEditEmitted', this.contentAttribute)
            }
          }
        )
      } else {
        if (this.actionIcons !== null) {
          if (this.actionIcons.edit !== undefined) {
            let callback = null
            if (this.actionIcons.edit === 'normal') {
              callback = e => {
                this.$emit('normalEditEmitted')
                this.openEditable(e)
              }
            } else if (this.actionIcons.edit === 'custom') {
              callback = e => {
                this.$emit('customEditEmitted')
              }
            }
            icons.push({
              icon: 'edit',
              tooltip: this.$i18n.t('buttons.edit'),
              callback: callback
            })
          }
          if (this.actionIcons.copy !== undefined) {
            icons.push({
              icon: 'far fa-copy',
              tooltip: this.copied ? this.$i18n.t('buttons.copied') : this.$i18n.t('buttons.copy'), // TODO: add to i18n
              callback: e => {
                /* eslint-disable no-sequences */
                /* eslint-disable vue/no-side-effects-in-computed-properties */
                // eslint-disable-next-line no-unused-expressions
                (this.copied = true),
                generalHelpers.copyToClipboard(this.actionIcons.copy)
              }
            })
          }
          if (this.actionIcons.expand !== undefined && this.actionIcons.expand) {
            if (this.isExpanded) {
              icons.push({
                icon: 'fas fa-angle-up',
                callback: e => {
                  this.isExpanded = !this.isExpanded
                }
              })
            } else {
              icons.push({
                icon: 'fas fa-angle-down',
                callback: e => {
                  this.isExpanded = !this.isExpanded
                }
              })
            }
          }
        }
      }
      return icons
    }
  },
  watch: {
    copied (newVal, oldVal) {
      if (newVal === true) {
        setTimeout((self = this) => {
          self.copied = false
        }, 3000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context-item--wrapper {
  .context--info__container {
    position: relative;
    display: flex;
    align-content: flex-start;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: left;
    justify-content: flex-start;
    margin-bottom: 1px;
    padding-left: 5px;
    border: 2px solid transparent !important;
    width: 100%;
    &.editing {
      background-color: transparent !important;
      border: 2px solid #767676 !important;
      border-radius: 5px;
      height: 29px;
      width: 100%;
    }
    &.custom-hover {
      background-color: #f2f2f2;
    }
    // &.editable {
    // &:hover {
    //   background-color: #f2f2f2;
    //   border: 0px solid #4c9aff;
    //   border-radius: 5px;
    //   width: 100%;
    // }
    // }
    .context--info__icon {
      flex: 1 1 auto;
      max-width: 16px;
      padding-top: 2.5px;
      &.placeholderLoader {
        margin-top: 2.5px;
        border: 0px solid;
        border-radius: 20px;
        width: 20px;
        height: 16px;
      }
      i {
        color: #767676;
        font-size: $iconFontSize;
      }
    }
    .context--info__text {
      flex: 1 1 auto;
      margin-left: 15px;
      .attribute {
        &.placeholderLoader {
          display: inline-block;
          margin-top: 2.5px;
          border: 0px solid;
          border-radius: 10px;
          width: 120px;
          height: 16px;
        }
        color: #767676;
        font-weight: bold;
        font-size: $subtitleFontSize;
      }
      .value {
        &.placeholderLoader {
          display: inline-block;
          margin-top: 2.5px;
          border: 0px solid;
          border-radius: 10px;
          width: 60px;
          height: 16px;
        }
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 70%;
        margin-left: 4px;
        color: #484848;
        font-weight: bold;
        font-size: $titleFontSize;
      }
      .editable--attribute {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: none;
        background-color: transparent;
        color: inherit;
        font-family: inherit;
        color: #767676;
        font-weight: bold;
        font-size: $subtitleFontSize;
        // width: inherit;
        width: 100%;
      }
      .editable--value {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: none;
        background-color: transparent;
        color: inherit;
        font-family: inherit;
        color: #484848;
        font-weight: bold;
        font-size: $titleFontSize;
        width: inherit;
      }
    }
    .list-item-card-big__actions-panel {
      position: absolute;
      right: 0;
      top: 0;
      background-color: #f2f2f2;
      height: calc(100% - 1px);
      display: flex;
      border-left: 1px solid #ededed;

      .icon-action {
        position: relative;
        // top: calc(50% - 9px);
        top: 0;
        // margin: 0 8px;
        width: 23px;
        height: 23px;
        text-align: center;
        border-radius: 5px;

        &:hover {
          background-color: #e0e0e0;
        }
      }
    }
  }
  .context--info__edit {
    z-index: 9;
    position: absolute;
    min-width: 100%;
    top: 28px;
    max-width: 100px;
    max-height: 150px;
    overflow-y: auto;
    ul {
      width: 100%;
      height: 100px;
      overflow: hidden;
      overflow-y: scroll;
      display: inline-block;
      position: absolute;
      background-color: #fff;
      border: 1px solid #767676;
      border-radius: 5px;
      top: 80px;
      left: 0;
      list-style-type: none;
      transform: translateY(-50%);
      padding: 0px 5px;
      li {
        width: 300px;
        font-size: $subtitleFontSize;
        color: #767676;
        font-weight: bold;
      }
    }
    div {
      display: flex;
      flex-direction: column;
      background-color: #ffffff;
      border: 1px solid #767676;
      border-radius: 5px;
      padding: 5px;
      margin: 0 2px;
      max-height: 150px;
      overflow-y: auto;
      a {
        margin-bottom: 5px;
        flex: 1 1 100%;
        display: block;
        font-size: $titleFontSize;
        font-weight: bold;
        color: #484848;
        padding-left: 5px;
        &:hover {
          background-color: rgba(0, 0, 0, 0.03);
        }
      }
    }
  }
}
</style>
